















































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import YcColorPicker from '@/components/color-picker/index.js';
import FontPicker from '@/components/FontPicker/index.vue';
import { predefineColors } from '../../../constant/options';
import { POP_WHEEL_CONFIG } from '@/views/wheelOfFortune/constant/popWheelConfig';
import { WheelConfig, WheelSlice } from '@/views/wheelOfFortune/constant/popWheelConfig';
import { ensureFileScopeAuthorized } from '@/services/fileScope';

@Component({
  name: 'CustomWheelEditor',
  components: {
    'yc-color-picker': YcColorPicker,
    'font-picker': FontPicker,
  }
})
class CustomWheelEditor extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly visible!: boolean;

  @Prop({ type: String, required: true })
  readonly uploadUrl!: string;

  @Prop({ type: String, required: true })
  readonly token!: string;

  @Prop({ type: Object, default: null })
  readonly value!: WheelConfig | null;

  @Prop({ type: Array, default: () => [] })
  readonly fontOptions!: Array<{ name: string; value: string }>;

  innerVisible: boolean = false;
  exporting: boolean = false;

  logicalSize: number = 800;
  dpr: number = window.devicePixelRatio || 1;

  config: WheelConfig = this.createDefaultConfig();

  activePanels: string[] = ['base', 'slices'];

  bgImage: HTMLImageElement | null = null;
  bgImageLoaded: boolean = false;
  bgImageObjectUrl: string | null = null;
  bgLoadSeq: number = 0;

  // 复用全局预设色
  predefineColors = predefineColors;

  created() {
    this.innerVisible = this.visible;
    if (this.value) {
      this.config = this.mergeWheelConfig(this.value);
    }
  }

  beforeDestroy() {
    if (this.bgImageObjectUrl) {
      URL.revokeObjectURL(this.bgImageObjectUrl);
      this.bgImageObjectUrl = null;
    }
  }

  @Watch('visible')
  onVisibleChange(v: boolean) {
    this.innerVisible = v;
  }

  @Watch('innerVisible')
  onInnerVisibleChange(v: boolean) {
    this.$emit('update:visible', v);
  }

  @Watch('value', { deep: true })
  onValueChange(v: WheelConfig | null) {
    if (v) {
      this.config = this.mergeWheelConfig(v);
      // 如果画布已初始化，则立即重绘以应用新的背景图
      this.$nextTick(() => {
        this.drawWheel();
      });
    }
  }

  handleOpen() {
    this.$nextTick(() => {
      this.initCanvas();
      this.drawWheel();
    });
  }

  handleCancel() {
    this.innerVisible = false;
    this.$emit('cancel');
  }

  async handleConfirm() {
    if (!this.config.slices || this.config.slices.length === 0) {
      this.$message.error(this.$tx('form.wheel.needSector', '请至少配置一个扇区'));
      return;
    }
    const canvas = this.$refs.wheelCanvas as HTMLCanvasElement;
    if (!canvas) {
      this.$message.error(this.$tx('form.wheel.canvasNotReady', '画布尚未初始化，请稍后重试'));
      return;
    }

    try {
      await ensureFileScopeAuthorized();
      this.exporting = true;
      let dataUrl: string;
      try {
        dataUrl = canvas.toDataURL('image/png');
      } catch (err) {
        // 跨域图片导致 canvas 被污染时，无法导出
        // 给出明确提示，方便运营调整素材来源
        // eslint-disable-next-line no-console
        console.error('canvas toDataURL error', err);
        this.$message.error(this.$tx('form.wheel.corsExport', '当前底图来源不支持导出，请使用同源或已开启 CORS 的图片素材'));
        this.exporting = false;
        return;
      }
      const blob = this.dataURLToBlob(dataUrl);
      const formData = new FormData();
      formData.append('file', blob, 'wheel.png');

      const res = await fetch(this.uploadUrl, {
        method: 'POST',
        headers: {
          token: this.token
        } as any,
        body: formData
      });

      if (!res.ok) {
        throw new Error(this.$tx('page.uploadFailed', '上传失败'));
      }

      const result = await res.json();
      // 兼容多种返回结构：
      // 1) { data: { url: '...' } }
      // 2) { data: [{ url: '...' }] }
      // 3) { url: '...' }
      let url: string =
        (result?.data && result.data.url) ||
        (Array.isArray(result?.data) && result.data[0] && result.data[0].url) ||
        result?.url ||
        '';

      if (!url) {
        throw new Error(this.$tx('form.noImageURLObtained', '未获取到图片地址'));
      }

      this.$emit('confirm', url, this.clone(this.config));
      this.innerVisible = false;
    } catch (e) {
      if ((e as any)?.handled) {
        return;
      }
      // eslint-disable-next-line no-console
      console.error(e);
      this.$message.error(this.$tx('form.wheel.exportFail', '导出或上传失败，请稍后重试'));
    } finally {
      this.exporting = false;
    }
  }

  onConfigChange() {
    const snapshot = this.clone(this.config);
    // eslint-disable-next-line no-console
    console.log('[CustomWheelEditor] config change', snapshot);
    this.$emit('input', snapshot);
    this.$emit('change', snapshot);
    this.drawWheel();
  }

  addSlice() {
    let next: WheelSlice;
    if (this.config.slices && this.config.slices.length > 0) {
      // 新增扇区默认复制第一个扇区的配置
      next = this.clone(this.config.slices[0]);
    } else {
      next = this.createDefaultSlice();
    }
    this.config.slices.push(next);
    this.onConfigChange();
  }

  copySlice(index: number) {
    if (!this.config.slices || !this.config.slices[index]) return;
    const cloned = this.clone(this.config.slices[index]);
    // 复制扇区直接追加到队尾
    this.config.slices.push(cloned);
    this.onConfigChange();
  }

  removeSlice(index: number) {
    if (this.config.slices.length <= 1) return;
    this.config.slices.splice(index, 1);
    this.onConfigChange();
  }

  initCanvas() {
    const canvas = this.$refs.wheelCanvas as HTMLCanvasElement;
    if (!canvas) return;

    const size = this.logicalSize;
    canvas.style.width = size + 'px';
    canvas.style.height = size + 'px';
    canvas.width = size * this.dpr;
    canvas.height = size * this.dpr;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    ctx.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
  }

  createDefaultSlice(): WheelSlice {
    return {
      fill: '#FFFFFF',
      border: {
        color: null,
        width: 1,
        style: 'solid'
      },
      label: {
        main: { text: '', size: 32, offsetY: 160 },
        sub: { text: '', size: 20, offsetY: 120 }
      }
    };
  }

  createDefaultConfig(): WheelConfig {
    return POP_WHEEL_CONFIG['188'];
  }

  mergeWheelConfig(raw: WheelConfig): WheelConfig {
    const defaultCfg = this.createDefaultConfig();
    const cfg: WheelConfig = {
      ...defaultCfg,
      ...raw,
      size: {
        ...defaultCfg.size,
        ...(raw.size || ({} as any))
      },
      colors: {
        ...defaultCfg.colors,
        ...(raw.colors || ({} as any)),
        backgrounds:
          raw.colors && raw.colors.backgrounds && raw.colors.backgrounds.length
            ? raw.colors.backgrounds
            : defaultCfg.colors.backgrounds
      },
      text: {
        ...defaultCfg.text,
        ...(raw.text || ({} as any))
      },
      slices: (raw.slices || defaultCfg.slices || []).map((s: any) => {
        const base = this.createDefaultSlice();
        const slice: any = {
          ...base,
          ...s,
          border: {
            ...base.border,
            ...(s.border || {})
          },
          label: {
            main: {
              ...base.label.main,
              ...(s.label && s.label.main)
            },
            sub: {
              ...base.label.sub,
              ...(s.label && s.label.sub)
            }
          }
        };
        return slice;
      })
    };
    return cfg;
  }

  deg2rad(deg: number) {
    return (deg * Math.PI) / 180;
  }

  get ctx(): CanvasRenderingContext2D | null {
    const canvas = this.$refs.wheelCanvas as HTMLCanvasElement;
    if (!canvas) return null;
    return canvas.getContext('2d');
  }

  drawBorder() {
    const ctx = this.ctx;
    if (!ctx) return;
    const baseCenterX = this.logicalSize / 2;
    const baseCenterY = this.logicalSize / 2;
    const centerX = baseCenterX + (this.config.size.centerOffsetX || 0);
    const centerY = baseCenterY + (this.config.size.centerOffsetY || 0);
    const radius = this.config.size.radius;
    const borderWidth = this.config.size.borderWidth;

    // 只有当边框宽度大于0时才绘制边框
    if (borderWidth <= 0) return;

    ctx.beginPath();
    ctx.arc(centerX, centerY, radius + borderWidth / 2, 0, Math.PI * 2);
    ctx.strokeStyle = this.config.colors.border;
    ctx.lineWidth = borderWidth;
    ctx.stroke();
  }

  getSliceFillColor(index: number) {
    const slice = this.config.slices[index];
    if (slice && slice.fill != null && slice.fill !== '') {
      return slice.fill;
    }
    const bgs = this.config.colors.backgrounds;
    if (Array.isArray(bgs)) {
      return bgs[index % bgs.length];
    }
    return (bgs as any) || '#FFFFFF';
  }

  drawSlices() {
    const ctx = this.ctx;
    if (!ctx) return;
    const baseCenterX = this.logicalSize / 2;
    const baseCenterY = this.logicalSize / 2;
    const centerX = baseCenterX + (this.config.size.centerOffsetX || 0);
    const centerY = baseCenterY + (this.config.size.centerOffsetY || 0);
    const radius = this.config.size.radius;
    const count = this.config.slices.length;
    const perDeg = 360 / count;

    for (let i = 0; i < count; i++) {
      const startTopDeg = -perDeg / 2 + i * perDeg;
      const endTopDeg = startTopDeg + perDeg;
      const startRad = this.deg2rad(startTopDeg - 90);
      const endRad = this.deg2rad(endTopDeg - 90);

      ctx.beginPath();
      ctx.moveTo(centerX, centerY);
      ctx.arc(centerX, centerY, radius, startRad, endRad);
      ctx.closePath();
      ctx.fillStyle = this.getSliceFillColor(i);
      ctx.fill();
    }

    for (let i = 0; i < count; i++) {
      const boundTopDeg = -perDeg / 2 + i * perDeg;
      const boundRad = this.deg2rad(boundTopDeg - 90);

      const leftIndex = (i + count - 1) % count;
      const leftSlice = this.config.slices[leftIndex];
      const edgeColor =
        leftSlice && leftSlice.border && leftSlice.border.color
          ? leftSlice.border.color
          : this.getSliceFillColor(leftIndex);
      const edgeWidth = (leftSlice && leftSlice.border && typeof leftSlice.border.width !== 'undefined' && leftSlice.border.width !== null) ? leftSlice.border.width : 1;
      const edgeStyle = (leftSlice && leftSlice.border && leftSlice.border.style) || 'solid';

      // 只有当边框宽度大于0时才绘制边框
      if (edgeWidth > 0) {
        ctx.strokeStyle = edgeColor || this.getSliceFillColor(leftIndex);
        ctx.lineWidth = edgeWidth;
        if (edgeStyle === 'dashed') {
          ctx.setLineDash([6, 4]);
        } else {
          ctx.setLineDash([]);
        }

        ctx.beginPath();
        ctx.moveTo(centerX, centerY);
        ctx.lineTo(centerX + radius * Math.cos(boundRad), centerY + radius * Math.sin(boundRad));
        ctx.stroke();
      }
    }
    ctx.setLineDash([]);
  }

  drawTexts() {
    const ctx = this.ctx;
    if (!ctx) return;
    const baseCenterX = this.logicalSize / 2;
    const baseCenterY = this.logicalSize / 2;
    const centerX = baseCenterX + (this.config.size.centerOffsetX || 0);
    const centerY = baseCenterY + (this.config.size.centerOffsetY || 0);
    const count = this.config.slices.length;
    const perDeg = 360 / count;

    for (let i = 0; i < count; i++) {
      const slice = this.config.slices[i];
      if (!slice) continue;

      const startTopDeg = -perDeg / 2 + i * perDeg;
      const midTopDeg = startTopDeg + perDeg / 2;
      const midRad = this.deg2rad(midTopDeg);

      ctx.save();
      ctx.translate(centerX, centerY);
      ctx.rotate(midRad);

      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillStyle = this.config.colors.text;

      const fontFamily = this.config.text.fontFamily;
      const mainLabel = slice.label.main;
      const subLabel = slice.label.sub;

      if (subLabel.text) {
        ctx.font = `700 ${subLabel.size}px ${fontFamily}`;
        ctx.fillText(subLabel.text, 0, -subLabel.offsetY);
      }
      if (mainLabel.text) {
        ctx.font = `800 ${mainLabel.size}px ${fontFamily}`;
        ctx.fillText(mainLabel.text, 0, -mainLabel.offsetY);
      }

      ctx.restore();
    }
  }

  drawWheel() {
    const ctx = this.ctx;
    if (!ctx) return;
    ctx.clearRect(0, 0, this.logicalSize, this.logicalSize);

    this.drawBorder();
    this.drawSlices();
    this.drawTexts();
  }

  normalizeImageUrl(url: string): string {
    // dev 环境下：对 CloudFront 图片走本地 devServer 代理，避免浏览器 CORS 拦截 fetch
    if (process.env.NODE_ENV !== 'development') return url;
    if (typeof window === 'undefined') return url;
    if (!/^https?:\/\//i.test(url)) return url;
    try {
      const u = new URL(url);
      if (u.hostname === 'dvamghaolyr74.cloudfront.net') {
        return `/__cf${u.pathname}${u.search || ''}`;
      }
    } catch (e) {
      // ignore invalid url
    }
    return url;
  }

  async loadImageByFetch(url: string): Promise<{ img: HTMLImageElement; objectUrl: string }> {
    const resolvedUrl = this.normalizeImageUrl(url);
    const res = await fetch(resolvedUrl);
    if (!res.ok) {
      throw new Error(`load image failed: ${res.status}`);
    }
    const blob = await res.blob();
    const objectUrl = URL.createObjectURL(blob);

    const img = new Image();
    img.src = objectUrl;
    await new Promise<void>((resolve, reject) => {
      img.onload = () => resolve();
      img.onerror = (e) => reject(e);
    });

    return { img, objectUrl };
  }

  async loadBackgroundAndDraw() {
    const url = this.config.size.backgroundImageUrl;
    // const url = "https://www.allbuy.com/cdn/shop/products/Magneet-Rubiks-kubus-Magische-blokken-Kinderen-Montagespeelgoed-Educatief-Bucky-Magnetische-staaf-Stalen-kogelset-Educatief-spee.jpg?v=1601396240&width=1646";
    if (!url) {
      this.bgImageLoaded = false;
      this.drawWheel();
      return;
    }

    const seq = ++this.bgLoadSeq;
    try {
      const { img, objectUrl } = await this.loadImageByFetch(url);
      if (seq !== this.bgLoadSeq) {
        URL.revokeObjectURL(objectUrl);
        return;
      }

      if (this.bgImageObjectUrl) {
        URL.revokeObjectURL(this.bgImageObjectUrl);
      }
      this.bgImageObjectUrl = objectUrl;

      this.bgImage = img;
      this.bgImageLoaded = true;
      this.drawWheel();
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('loadBackgroundAndDraw error', e);
      this.bgImageLoaded = false;
      this.drawWheel();
    }
  }

  dataURLToBlob(dataUrl: string): Blob {
    const arr = dataUrl.split(',');
    const mimeMatch = arr[0].match(/:(.*?);/);
    const mime = mimeMatch ? mimeMatch[1] : 'image/png';
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }

  clone<T>(v: T): T {
    return JSON.parse(JSON.stringify(v));
  }
}

export default CustomWheelEditor;
